// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';

const getState = (state) => state?.buyItAgainBagPage;
const allModules = (state) => state?.Modules;

export const getIsShopAllDrawerOpen = createSelector(getState, (state) => state?.openShopAllDrawer);
export const getBIAAvailProduct = createSelector(getState, (state) => state?.biaProductAvailable);

export const allModulesData = createSelector(allModules, (allModulesDta) => allModulesDta);

export const getBIAContentId = () => {
  const { referred } = getDynamicLabelValues('checkout.bagPage');
  return referred?.[0]?.contentId;
};

export const getBIADynamicData = createSelector(
  [allModules, getBIAContentId],
  (modulesDta, biaContentId) => {
    //     const biaData = state.Modules['8ee1f354-f470-490d-a804-ab2db6a8c0fa']
    //   return referred?.[0]?.contentId;
    return modulesDta?.[biaContentId];
  }
);

export const getBIACarouselStaticProductCount = createSelector(
  getBIADynamicData,
  (biaDynamicData) => biaDynamicData?.noOfProducts
);
